/*
  Copyright (c) 2018-present, Accuracy.
  All rights reserved.
*/
import {createStyles, StyleRules, Theme} from "@material-ui/core";
import makeStyles from '@material-ui/core/styles/makeStyles';
import classNames from 'classnames';
import React, {memo} from 'react';
import {useTranslation} from "react-i18next";

//----------------------------------------------------------------------------------------------------------------------
//- Styles
//----------------------------------------------------------------------------------------------------------------------
export type LegalClassKey = 'root' | 'heading' | 'paragraph';

const useStyles = makeStyles<Theme, {}, LegalClassKey>(
  (): StyleRules<LegalClassKey> =>
    createStyles({
      root: {
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        maxWidth: '72ch',
        padding: 'clamp(48px, 10vh, 120px) clamp(20px, 4vw, 56px) clamp(60px, 10vh, 120px)'
      },
      heading: {
        margin: '0 0 4px',
        fontFamily: 'var(--font-display)',
        fontSize: 'clamp(26px, 3vw, 40px)',
        letterSpacing: '-.01em'
      },
      paragraph: {
        margin: 0,
        fontSize: '14px',
        lineHeight: 1.8,
        color: 'var(--color-text-body)'
      }
    }),
  {
    name: 'Legal'
  });

//----------------------------------------------------------------------------------------------------------------------
//- Component
//----------------------------------------------------------------------------------------------------------------------
export type LegalProps = {
  className?: string;
};

export default memo(({className}: LegalProps) => {
  // hooks
  const classes = useStyles({});
  const {t} = useTranslation('common');

  return (
    <div className={classNames(classes.root, className)}>
      <h2 className={classes.heading}>{t('legal.warning')}</h2>
      <p className={classes.paragraph}>{t('legal.p1')}</p>
      <p className={classes.paragraph}>{t('legal.link')}</p>
      <p className={classes.paragraph}>{t('legal.p2')}</p>
      <p className={classes.paragraph}>{t('legal.p3')}</p>
    </div>
  );
});
